import { Component, EventEmitter, OnInit, Output, Query, ViewChild } from '@angular/core';
import { BaseDataService, BaseTabsUpdateComponent, TabsContainerService, UserService, QueryParameter, ModalService, ConfirmationDialogButtons, ErrorHandlerService, NotificationService } from 'yt-ng-framework';
import { PojedinacnaEvidencijaPdv } from './pojedinacna-evidencija-pdv';
import { ActivatedRoute } from '@angular/router';
import { PojedinacnaEvidencijaPdvUpdateComponent } from './pojedinacna-evidencija-pdv-update.component';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { PojedinacnaEvidencijaPdvView } from './pojedinacna-evidencija-pdv-view';
import { HttpErrorResponse } from '@angular/common/http';
import { concatMap, switchMap } from 'rxjs/operators';
import { from } from 'rxjs';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-pojedinacna-evidencija-pdv-tab-update',
  templateUrl: './pojedinacna-evidencija-pdv-tab-update.component.html'
})
export class PojedinacnaEvidencijaPdvTabUpdateComponent 
  extends BaseTabsUpdateComponent<PojedinacnaEvidencijaPdv> 
  implements OnInit {
    formControlDataName: string;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<PojedinacnaEvidencijaPdv>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected translateService: TranslateService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected errorService: ErrorHandlerService
  ) { 
    super(activatedRoute, tabsContainerService, baseDataService, userService)
  }

  @ViewChild('baseUpdate', { static: true }) pojedinacnaBaseUpdate: PojedinacnaEvidencijaPdvUpdateComponent;
  @Output() DocumentSentToSef = new EventEmitter(false);
  loadingSendEUInvoice: boolean = false;
  loadingSendEUInvoiceV2: boolean = false;
  loadingSendEUInvoiceV1OrV2: boolean = false;

  bojaStatusa = "transparent";
  loadingIndividualVatStatus: boolean = false;
  loadingIndividualVatStatusv2: boolean = false;
  loadingIndividualVatStatusV1OrV2: boolean = false;

  ngOnInit() {
    super.ngOnInit();
    
    this.baseUpdateComponent.IDProcessed.subscribe((value) => {
      if (value && this.baseUpdateComponent.Item.ID > 0)
        this.bojaStatusa = this.baseUpdateComponent.Item.StatusColor;
        // this.RefreshStatusEUInvoice(this.baseUpdateComponent.Item.ID);
        // console.log(value);
      else
        // 18.1.2023
        this.bojaStatusa = "transparent";
    });
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
  }

  ColorChange(event){
    this.bojaStatusa = event;
  }

  //  CreateMessage(){
  //   return 'Obaveštenje! Napravili ste izmenu na izvornom dokumentu, koji je vezan za ovu pojedinačnu evidenciju, potrebno je sacuvati dokument pre daljeg rada.'
  // }

  RefreshStatusClick(){
    this.RefreshStatusIndividualVatRecord(this.baseUpdateComponent.Item.ID);
  }

  RefreshStatusV2Click(){
    this.RefreshStatusIndividualVatRecordV2(this.baseUpdateComponent.Item.ID);
  }

  RefreshStatusV1OrV2Click(){
    if ((this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==1 && this.baseUpdateComponent.Item.PeriodId>=9)
      || (this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==2 && this.baseUpdateComponent.Item.PeriodId>=15)
      || this.baseUpdateComponent.Item.Godina>2024)
      this.RefreshStatusIndividualVatRecordV2(this.baseUpdateComponent.Item.ID);
    else
      this.RefreshStatusIndividualVatRecord(this.baseUpdateComponent.Item.ID);
  }

  SendIndividualVatRecording(item : PojedinacnaEvidencijaPdv){
    // let nastaviSlanje: boolean = true; 
    // if (!this.baseUpdateComponent.canDeactivate())
    // {
    //   if (confirm('Dokument nije sačuvan. Sačuvaj i pošalji?')){
    //     this.baseUpdateComponent.SaveItem();
    //     if (!(this.baseUpdateComponent.baseInlineContainer && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent
    //       && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()))
    //       this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
    //       item = this.baseUpdateComponent.Item;
    //       nastaviSlanje = true;
    //   }
    //   else {
    //     nastaviSlanje = false;
    // }
    // }
    // if (nastaviSlanje && this.baseUpdateComponent.baseFormGroup.valid){
      let _id : Number = item.ID;
      let _masterDokumID : Number = item.MasterDokumID;

      var /** @type {?} */ parameters1 = [];
      var /** @type {?} */ parameter = new QueryParameter();
      parameter.Name = 'masterDokumID';
      parameter.Value = _masterDokumID.toString();
      parameters1.push(parameter);
      let salji = true;
      //  this.baseDataService.Get(
      //    'PojedinacnaEvidencijaPdv'
      //    , 'GetDocStatusGenericName'
      //    , parameters1
      //    , null
      //  ).subscribe(data => {
      //    let salji=true;

      //    this.baseDataService.Get('PojedinacnaEvidencijaPdv','GetDocStatusNaziv',[new QueryParameter('genericName', data.toString())],null)
      //    .subscribe(dataNaziv => {
      //      if (data && data.toString().toLocaleLowerCase()!="unknown"
      //      && (
      //        (data.toString().toLowerCase()=="sent" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta", "Dokument je već poslat na portal.", "warning",ConfirmationDialogButtons.Ok))
      //        || (data.toString().toLowerCase()=="delivered" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta","Dokument je već isporučen.",'warning',ConfirmationDialogButtons.Ok)) 
      //        || confirm("Status pojedinačne evidencije je "+dataNaziv.toString()+" da li zaista želite da ga pošaljete na portal?")==false
      //      )
      //      ){
      //        salji=false;
      //      }
          if(salji){
            //let IdParameter = new QueryParameter("ID",_id);  
            //let masterIdParameter = new QueryParameter("masterDokumID",_masterDokumID);  
                       
            // this.loadingSendEUInvoice=true;  
            this.loadingSendEUInvoiceV1OrV2=true;  
            let parameters = {'ID' : _id, 'masterDokumID' : _masterDokumID};
              this.baseDataService.Post('PojedinacnaEvidencijaPdv', 'SendIndividualVatRecording', parameters, PojedinacnaEvidencijaPdv, null)
                .subscribe((result : any) =>{
                  //  this.loadingSendEUInvoice=false;  
                  this.DocumentSentToSef.emit(true);  
                   this.loadingSendEUInvoiceV1OrV2=false;  
                   this.translateService.get(["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"])
                   .subscribe(translate => {
                      // this.notificationService.success(translate["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"]); 
                      this.toastrService.success(translate["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"]); 
                      this.baseUpdateComponent.Item.OsvezivogStatusa = true;  
                      this.RefreshStatusClick();          
                  })
                }  
                      
                ,error => {
                  // this.loadingSendEUInvoice=false; 
                  this.loadingSendEUInvoiceV1OrV2=false;  
                  let _message; 
                  if(error instanceof HttpErrorResponse){
                    _message = this.errorService.getServerMessage(error);
                  }
                  if (_message.includes("EDOKUMENT")){
                    _message = "FW.ERRORS." + _message;
                  }
                  
                      this.translateService.get(_message)
                        .subscribe(translate => {
                          this.modalService.ShowConfirmationDialog("Problemi kod slanja", translate, "warning", ConfirmationDialogButtons.Ok);
                        });
                  
                }
              )
                    

                
          // }

      //   });
      // });
    }
  }

  SendIndividualVatRecordingV2(item : PojedinacnaEvidencijaPdv){
    // let nastaviSlanje: boolean = true; 
    // if (!this.baseUpdateComponent.canDeactivate())
    // {
    //   if (confirm('Dokument nije sačuvan. Sačuvaj i pošalji?')){
    //     this.baseUpdateComponent.SaveItem();
    //     if (!(this.baseUpdateComponent.baseInlineContainer && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent
    //       && this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate()))
    //       this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
    //       item = this.baseUpdateComponent.Item;
    //       nastaviSlanje = true;
    //   }
    //   else {
    //     nastaviSlanje = false;
    // }
    // }
    // if (nastaviSlanje && this.baseUpdateComponent.baseFormGroup.valid){
      let _id : Number = item.ID;
      let _masterDokumID : Number = item.MasterDokumID;

      var /** @type {?} */ parameters1 = [];
      var /** @type {?} */ parameter = new QueryParameter();
      parameter.Name = 'masterDokumID';
      parameter.Value = _masterDokumID.toString();
      parameters1.push(parameter);
      let salji = true;
     
          if(salji){
                       
            // this.loadingSendEUInvoiceV2=true;  
            this.loadingSendEUInvoiceV1OrV2=true;
            let parameters = {'ID' : _id, 'masterDokumID' : _masterDokumID};
              this.baseDataService.Post('PojedinacnaEvidencijaPdv', 'SendIndividualVatRecordingV2', parameters, PojedinacnaEvidencijaPdv, null)
                .subscribe((result : any) =>{
                  //  this.loadingSendEUInvoiceV2=false;
                  this.DocumentSentToSef.emit(true);  
                   this.loadingSendEUInvoiceV1OrV2=false;   
                   this.translateService.get(["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"])
                   .subscribe(translate => {
                      // this.notificationService.success(translate["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"]); 
                      this.toastrService.success(translate["POJEDINACNAEVIDENCIJAPDV.SENT.SUCESS"]); 
                      this.baseUpdateComponent.Item.OsvezivogStatusa = true;  
                      this.RefreshStatusV2Click();          
                  })
                }  
                      
                ,error => {
                  // this.loadingSendEUInvoiceV2=false; 
                  this.loadingSendEUInvoiceV1OrV2=false;  
                  let _message; 
                  let translatedMessage: string = ""; 
                  if(error instanceof HttpErrorResponse){
                    _message = this.errorService.getServerMessage(error);
                  }
                    // _message = "FW.ERRORS." + _message;
                    if (_message.includes("EDOKUMENT")){
                      let messageArray: string[] = _message.split(';');   
                      messageArray.forEach((element, index) => {
                        messageArray[index] = "FW.ERRORS." + element;
                      });
                      this.translateService.get(messageArray)
                      .subscribe(translate => {
                        translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
                      });
                    }
                    else
                      translatedMessage = _message;   
                      this.translateService.get(translatedMessage)
                        .subscribe(translate => {
                          this.modalService.ShowConfirmationDialog("Problemi kod slanja", translate, "warning", ConfirmationDialogButtons.Ok);
                        });
                       
                      }
                      ) 

                
          // }

      //   });
      // });
    }
  }

  SendIndividualVatRecordingV1OrV2(item:PojedinacnaEvidencijaPdv){
    let nastaviSlanje: boolean = true; 
    if (!this.baseUpdateComponent.canDeactivate()){
      if (confirm('Dokument nije sačuvan. Sačuvaj i pošalji?')){       
        this.baseUpdateComponent.SaveItem().then(()=>{
          item = this.baseUpdateComponent.Item;
          if (this.baseUpdateComponent.baseFormGroup.valid){
            if ((this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==1 && this.baseUpdateComponent.Item.PeriodId>=9)
              || (this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==2 && this.baseUpdateComponent.Item.PeriodId>=15)
              || this.baseUpdateComponent.Item.Godina>2024)
                this.SendIndividualVatRecordingV2(item);      
            else
              this.SendIndividualVatRecording(item);
          }
        })
        .catch((error) => {
          console.error('Greška prilikom čuvanja:', error);
          nastaviSlanje = false;
      });
        
      }        
      // else
      //   nastaviSlanje = false;
    }
    else{
      if (this.baseUpdateComponent.baseFormGroup.valid){
        if ((this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==1 && this.baseUpdateComponent.Item.PeriodId>=9)
          || (this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==2 && this.baseUpdateComponent.Item.PeriodId>=15)
          || this.baseUpdateComponent.Item.Godina>2024)
            this.SendIndividualVatRecordingV2(item);      
        else
          this.SendIndividualVatRecording(item);
      }
    }

    // if (nastaviSlanje && this.baseUpdateComponent.baseFormGroup.valid){
    //   if ((this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==1 && this.baseUpdateComponent.Item.PeriodId>=9)
    //     || (this.baseUpdateComponent.Item.Godina>=2024 && this.baseUpdateComponent.Item.PoreskiPeriodId==2 && this.baseUpdateComponent.Item.PeriodId>=15)
    //     || this.baseUpdateComponent.Item.Godina>2024)
    //       this.SendIndividualVatRecordingV2(item);      
    //   else
    //     this.SendIndividualVatRecording(item);
  }

  RefreshStatusIndividualVatRecord(id: number) {
    if (id > 0) {
      // this.loadingIndividualVatStatus = true;
      this.loadingIndividualVatStatusV1OrV2 = true;
      let idParameter = [new QueryParameter("id", id)];
        if (this.baseUpdateComponent.Item.OsvezivogStatusa) {
          this.baseDataService
            .Get("PojedinacnaEvidencijaPdv", "OsveziStatus", idParameter, PojedinacnaEvidencijaPdvView)
            .subscribe((data: PojedinacnaEvidencijaPdvView[]) => {
              if (data != null && data.length > 0)
                this.bojaStatusa = data[0].StatusColor;
              else this.bojaStatusa = "transparent";  
              
              // za zakljucavanje
              this.baseDataService.GetByID("PojedinacnaEvidencijaPdv",id,PojedinacnaEvidencijaPdv)
              .subscribe((data: PojedinacnaEvidencijaPdv) => {
                if (data)
                  this.baseUpdateComponent.Item = data;
                  this.baseUpdateComponent.ItemLoaded.emit(this.baseUpdateComponent.Item);
              })
            }
            ,error => {
              throw error;       
            }
            );
        } else {
          this.baseDataService
            .Get("PojedinacnaEvidencijaPdv", "GetViewItemByID", idParameter, PojedinacnaEvidencijaPdvView)
            .subscribe((data:any) => {
              if (data != null && data.StatusColor!=null)
                this.bojaStatusa = data.StatusColor;
              else this.bojaStatusa = "transparent";
              
            }
            ,error => {
              throw error;       
            }
            );
          if (this.baseUpdateComponent.Item.ProvajderID){
            this.translateService.get('EDOKUMENT.STATUS.NEMOZEDAOSVEZI')
            .subscribe(translate => {
              window.alert(translate);
            })
          }
        }
        // this.loadingIndividualVatStatus = false;
        this.loadingIndividualVatStatusV1OrV2 = false;
      }
    }

    RefreshStatusIndividualVatRecordV2(id: number) {
      if (id > 0) {
        // this.loadingIndividualVatStatusv2 = true;
        this.loadingIndividualVatStatusV1OrV2 = true;
        let idParameter = [new QueryParameter("id", id)];
          if (this.baseUpdateComponent.Item.OsvezivogStatusa) {
            this.baseDataService
              .Get("PojedinacnaEvidencijaPdv", "OsveziStatusV2", idParameter, PojedinacnaEvidencijaPdvView)
              .subscribe((data: PojedinacnaEvidencijaPdvView[]) => {
                if (data != null && data.length > 0)
                  this.bojaStatusa = data[0].StatusColor;
                else this.bojaStatusa = "transparent";  
                
                // za zakljucavanje
                this.baseDataService.GetByID("PojedinacnaEvidencijaPdv",id,PojedinacnaEvidencijaPdv)
                .subscribe((data: PojedinacnaEvidencijaPdv) => {
                  if (data)
                    this.baseUpdateComponent.Item = data;
                    this.baseUpdateComponent.ItemLoaded.emit(this.baseUpdateComponent.Item);
                })

                if(data[0].StatusGenericName == "20"){
                  this.modalService.ShowConfirmationDialog(
                    "Obaveštenje",
                    "Vaš dokument je statusa 'Korigovan'! Potrebno je da napravite izmene na izvornom dokumentu koje su usaglašene sa poslednjim dokumentom pojedinačne evidencije na SEF-u. "+
                    "Nakon toga se možete vratiti na ovu stranicu prihvatiti izmene sa izvornog dokumenta.",
                    "warning",
                    ConfirmationDialogButtons.Ok
                  ).result.then((result) => {});
                }
              }
              ,error => {
                throw error;       
              }
              );
          } else {
            this.baseDataService
              .Get("PojedinacnaEvidencijaPdv", "GetViewItemByID", idParameter, PojedinacnaEvidencijaPdvView)
              .subscribe((data:any) => {
                if (data != null && data.StatusColor!=null)
                  this.bojaStatusa = data.StatusColor;
                else this.bojaStatusa = "transparent";
                
              }
              ,error => {
                throw error;       
              }
              );
            if (this.baseUpdateComponent.Item.ProvajderID){
              this.translateService.get('EDOKUMENT.STATUS.NEMOZEDAOSVEZI')
              .subscribe(translate => {
                window.alert(translate);
              })
            }
          }
          // this.loadingIndividualVatStatusv2 = false;
          this.loadingIndividualVatStatusV1OrV2 = false;
        }
      }


  }
